// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__xgOoe","logo":"MainNavigation_logo__5F37V"};